import { Page } from '@components';
import { useFlagFixed, useRequiredParams } from '@hooks';
import { Stack } from '@mui/material';
import { routes } from '@routes';

import AssessmentReportTable from '@StandingAccess/organisms/AssessmentReport';
import AssessmentReportFilters from '@StandingAccess/organisms/AssessmentReportFilters';
import AssessmentReportDrawer from '@StandingAccess/organisms/AssessmentReportDrawer';
import AssessmentReportHeaderItem from '@StandingAccess/organisms/AssessmentReportHeaderItem';
import AssessmentReportWidgets from '@StandingAccess/organisms/AssessmentReportWidgets';
import {
  ASSESSMENT_REPORT_IN_ACCESS_FLOW_FILTER,
  ASSESSMENT_REPORT_PERMISSIONS_FILTER,
  ASSESSMENT_REPORT_RESOURCES_FILTER,
  ASSESSMENT_REPORT_REVOKED_FILTER,
  ASSESSMENT_REPORT_RISK_SCORE_FILTER,
  ASSESSMENT_REPORT_TIER_FILTER,
} from '@StandingAccess/types';
import AssessmentReportRemediation from '@StandingAccess/organisms/AssessmentReportRemediation';
import { Flag } from '@utils';

export default function ViewStandingAccessReportPage() {
  const { id } = useRequiredParams(['id']);
  const { isEnabled: isAccessFlowEnabled } = useFlagFixed(Flag.ASSESSMENT_REPORTS_ACCESS_FLOW);

  const filters: string[] = [
    ASSESSMENT_REPORT_TIER_FILTER.param,
    ASSESSMENT_REPORT_RESOURCES_FILTER.param,
    ASSESSMENT_REPORT_PERMISSIONS_FILTER.param,
    ASSESSMENT_REPORT_RISK_SCORE_FILTER.param,
    ASSESSMENT_REPORT_REVOKED_FILTER.param,
  ];

  if (isAccessFlowEnabled) {
    filters.push(ASSESSMENT_REPORT_IN_ACCESS_FLOW_FILTER.param);
  }

  return (
    <Page
      title={routes.ViewStandingAccessReport.label}
      breadcrumbs={[{ label: routes.StandingAccessReports.label, href: routes.StandingAccessReports.path }]}
    >
      <Stack direction="column" justifyContent="center" alignItems="stretch" spacing={2}>
        <AssessmentReportHeaderItem reportId={id} />
        <AssessmentReportWidgets reportId={id} />
        <AssessmentReportFilters reportId={id} allowedFilters={filters} />
        <AssessmentReportTable reportId={id} />
      </Stack>
      <AssessmentReportDrawer reportId={id} />
      {isAccessFlowEnabled && <AssessmentReportRemediation reportId={id} />}
    </Page>
  );
}
